var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInnoqinline = function SvgInnoqinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226,
    height: 35,
    fill: "none",
    viewBox: "0 0 226 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7993",
    d: "M.4 1.9h12.5v52.5H.4zM103.3 54.4V1.9H90.8V34l-24-32.1h-12V34L30.9 1.9h-12v52.5h12.5v-32l23.9 32h12.1v-32l23.9 32zM135.3 12.9c8.5 0 14.6 6.2 14.6 15.2s-6.1 15.2-14.6 15.2c-8.6 0-14.6-6.2-14.6-15.2s6.1-15.2 14.6-15.2m0-12c-16.2 0-27.7 11.6-27.7 27.2s11.5 27.2 27.7 27.2S163 43.7 163 28.1 151.5.9 135.3.9M194.2 12.9c8.5 0 14.6 6.2 14.6 15.2q0 2.55-.6 4.8l-1.7-2.3h-13.6l8.3 11.1c-2 1-4.4 1.6-6.9 1.6-8.5 0-14.6-6.2-14.6-15.2-.1-8.9 6-15.2 14.5-15.2m0-12c-16.2 0-27.7 11.6-27.7 27.2s11.5 27.2 27.7 27.2c5.5 0 10.2-1.5 14.2-4.1l2.3 3.1h14.7l-8.3-11.2c2.9-4.2 4.6-9.1 4.6-15C221.9 12.5 210.4.9 194.2.9"
  })));
};
export default SvgInnoqinline;